import { ApiKey, ApiPathManager, ServiceCode } from "app/shared/services/api-path";
import { getDataHeaders, getUserHeader, getUserParam } from "app/shared/services/header-builder";
import { REQUESTINPUT } from "app/shared/services/services-model.type";
import store from "app/shared/store/store";
import { instance } from "app/shared/util/token-store";
import { nonAccentVietnamese, replaceEnterKey, replaceSpace } from "app/shared/util/validate";
import { DataTopUpCreate, FetchTopUpAuthorizationRequest, FetchTopUpConfirmRequest } from "../reducer/types";

const createParam = (dataCreate: DataTopUpCreate): REQUESTINPUT => {
  const description = replaceEnterKey(replaceSpace(nonAccentVietnamese(dataCreate.SERVICE?.label.trim())));
  const params: REQUESTINPUT = {
    USERPROFILE: getUserHeader(),
    ACCOUNTPROFILE: {
      ACCOUNTNO: dataCreate.ACCOUNT_DEBIT?.ACCOUNTNO,
      ACCOUNTTYPE: dataCreate.ACCOUNT_DEBIT?.ACCOUNTTYPE,
    },
    EBINQUIRY: {
      SERVICE_CODE: dataCreate.SERVICE?.value,
      INQUIRY_CODE: dataCreate.INQUIRY_CODE,
    },
    TRANSFER: {
      SERVICE_CODE: dataCreate.SERVICE_CODE,
      DEBIT_ACCOUNT_NUMBER: dataCreate.ACCOUNT_DEBIT?.ACCOUNTNO,
      DEBIT_ACCOUNT_TYPE: dataCreate.ACCOUNT_DEBIT?.ACCOUNTTYPE,
      TRANSACTION_AMOUNT: dataCreate.AMOUNT,
      TRANSACTION_DESCRIPTION: description + " " + dataCreate.INQUIRY_CODE,
      USERPROFILE: getUserParam(),
    },
  };
  if (dataCreate.SERVICE_CODE === ServiceCode.PAYMENT_TOP_UP_OTHER) {
    params.EBINQUIRY = {
      ...params.EBINQUIRY,
      PROVIDER_CODE: dataCreate.PROVIDER?.value || "",
    };
  }
  return params;
};

const confirmParam = (action: FetchTopUpConfirmRequest): REQUESTINPUT => {
  const params: REQUESTINPUT = {
    USERPROFILE: getUserHeader(),
    EBINQUIRY: action.payload?.EBINQUIRY,
    TRANSFER: {
      ...action.payload?.TRANSFER,
      USERPROFILE: getUserHeader(),
    },
  };
  return params;
};

const authParam = (action: FetchTopUpAuthorizationRequest): REQUESTINPUT => {
  const EBINQUIRY = store.getState().topUp.responseCreate?.EBINQUIRY;
  const params: REQUESTINPUT = {
    AUTHORIZE_CODE: action.code,
    CHALLENGE_ID: action.payload?.CHALLENGE_ID,
    USERPROFILE: getUserHeader(),
    EBINQUIRY: EBINQUIRY,
    TRANSFER: {
      RQSTSEQ: action.payload?.TRANSFER?.RQSTSEQ || "",
      USERPROFILE: getUserParam(),
    },
  };
  return params;
};

export const fetchTopUpInfoService = async () => {
  const { action, massageID, url } = ApiPathManager(ApiKey.PAYMENT_TOP_UP_INFO);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

export const fetchTopUpCreateService = async (dataCreate: DataTopUpCreate) => {
  const params: REQUESTINPUT = createParam(dataCreate);
  const { action, massageID, url } = ApiPathManager(ApiKey.PAYMENT_TOP_UP_CREATE);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    ...params,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

// Xác nhận chuyển tiền
export const fetchTopUpConfirmService = async (actionRq: FetchTopUpConfirmRequest) => {
  const params: REQUESTINPUT = confirmParam(actionRq);
  const { action, massageID, url } = ApiPathManager(ApiKey.PAYMENT_TOP_UP_CHECK_INFO);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    ...params,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};

export const fetchTopUpAuthService = async (actionRq: FetchTopUpAuthorizationRequest) => {
  const params: REQUESTINPUT = authParam(actionRq);
  const { action, massageID, url } = ApiPathManager(ApiKey.PAYMENT_TOP_UP_AUTHORIZE_INFO);
  const header = getDataHeaders(massageID, action);
  const userProfile = getUserHeader();
  const requestInput: REQUESTINPUT = {
    USERPROFILE: userProfile,
    ...params,
  };
  const body = {
    HEADER: header,
    REQUESTINPUT: requestInput,
  };
  console.log("body: ", body);
  const response: any = await instance.post(url, body);
  return response;
};
